import React from "react";
import { Badge, Box, Button, Grid, IconButton, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import CachedIcon from "@material-ui/icons/Cached";
import NotificationsIcon from "@material-ui/icons/Notifications";

interface Props {
  closeDrawer: any;
  heading: string;
  callbackFun?: any;
  border?: boolean;
  isRequiredRefresh?: boolean;
}

export default function DrawerHeader({
  closeDrawer,
  heading,
  callbackFun,
  border,
  isRequiredRefresh = true,
}: Props) {
  const classes = useStyles();
  return (
    <Grid container direction="row">
      <Grid item xs={12} md={12}>
        <Box className={classes.swipeableDrawer}>
          <Grid
            container
            direction="row"
            className={border ? classes.drawerHeader : classes.drawerHeaderWithoutBorder}
          >
            <Grid item xs={12} md={10}>
              <Box ml={0} mt={1} color="text.secondary">
                <Typography component="span" variant="h6" color="textPrimary">
                  {heading === "Notifications" ? (
                    <IconButton style={{ padding: "0 10px 0 0" }} className={classes.icon}>
                      <Badge color="secondary">
                        <NotificationsIcon />
                      </Badge>
                    </IconButton>
                  ) : (
                    <></>
                  )}
                  <span>{heading}</span>
                  {heading === "Notifications" ? (
                    <></>
                  ) : (
                    <>
                      {isRequiredRefresh && (
                        <span className="icon">
                          <CachedIcon
                            onClick={() => {
                              callbackFun();
                            }}
                          />
                        </span>
                      )}
                    </>
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2}>
              <Box textAlign="right">
                <Box component="span">
                  <Button
                    className={classes.closeDrawer}
                    onClick={() => {
                      closeDrawer();
                    }}
                  >
                    ×
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}
